module.exports = __webpack_public_path__ + "img/tv.6c6bdb16.svg";